// extracted by mini-css-extract-plugin
export default {"preferences-btn-gray":"styles-module__preferences-btn-gray___GpM2W"};